import store from "../store";
import Request from "./request";
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import consts from "@/consts.js";


async function fetch(data) {
  if (!data) data = {};
  data.fieldFilter = [
    "id",
    "purchase_code",
    "created",
    "complete_date",
    "third_return",
    "Stock.name",
    "Supplier.supplier_name",
    "Supplier.type",
    "hope_delivery_date",
    "status",
    "logistics_json",
    "origin_flg",
    "check_flg",
    "delivery_flg",
    "supplier_id",
    "order_code"
  ]; //仅筛选少许必要字段
  return Request("get", "api/purchases/", data);
}

async function fetchOne(id,data){
    return Request("get","api/purchases/" + id,data)
}

async function fetchExamineDetail(id,data){
  return Request("get","api/purchases/examine-view/" + id,data)
}

function delSomeFields(data) {// 去除过多杂项
  data = JSON.parse(JSON.stringify(data));// 深拷贝避免修改原数据
  delete data.actions;
  delete data.creater;
  return data;
}

async function addPreview(data) {// 新建订单预览
  data = delSomeFields(data);// 去除过多杂项
  return Request('post', "api/purchases/add-view", data);
}

async function addIntelligentPreview(data) {// 新建订单预览
  return Request('post', "api/purchases/add-views", data);
}

async function add(data){
  // isNew
  data = delSomeFields(data)
  return Request('patch',"api/purchases/add", data)

}
async function addIntelligent(data){
  return Request('patch',"api/purchases/add", data)

}

async function cancel(id){
  return Request("delete",'api/purchases/cancel/' + id)
}

async function clone(id){
  return Request("delete",'api/purchases/copy/' + id)
}

async function examineBatchExports(data){
  store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/purchases/examineBatchExport",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function examineExport(id){
  store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/purchases/purchaseExamineExport/"+id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function exports(id){
  store.dispatch("fullscreenLoading");
    const response = await Request('get',"api/purchases/purchase-export/" + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function examine(data){
  return Request("post","api/purchases/examine",data)
}

async function confirm(data){
  return Request("patch","api/purchases/confirm",data)
}

async function edit(id,data){
  return Request('patch',"api/purchases/edit/" + id, data)
}

async function batchConfirm(data){
  return Request('patch','api/purchases/batch-confirm',data)
}

async function batchExamine(data){
  return Request('patch','api/purchases/batch-examine',data)
}

async function stockoutFetch(data) {
  return Request('get', "api/purchases/short/", data)
}

async function purchasePrint(id){
  return Request('get','api/purchases/'+id)
}

async function purchasesPrint(data){
  data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
  return Request('get','api/purchases/index/PRE_PRINT/',data)
}

async function pushAgain(id) {
  return Request('post', "api/shuhai/receive-purchase-order/" + id);
}

async function purchaseToSupplierOrder(id) {
  return Request('get', 'api/purchases/purchase-to-supplier-order/' + id)
}


async function templateExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/purchases/template-export/', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function Import(file) {// 导入
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/purchases/import",data)
}

async function fetchIntelligentDetails(data) {
  return Request("get", "api/purchases/get-intelligent-purchase-details", data);
}

async function fetchIntelligentPurchaseOrders(data) {
  return Request("get", "api/purchases/get-intelligent-purchase-orders", data);
}

async function getNegotiatePriceDetails(data) {
  return Request("get", "api/purchases/getNegotiatePriceDetails", data);
}

async function negotiatePriceSave(data) {
  return Request('post', "api/purchases/negotiatePriceSave", data);
}
async function negotiatePriceBatchSave(data) {
  return Request('post', "api/purchases/negotiatePriceBatchSave", data);
}

async function editHopeDeliveryDate(data) {
  return Request('post', "api/purchases/edit-hope-delivery-date", data);
}

async function orderToPurchaseError() {
  return Request('get', "api/purchases/order-to-purchase-error");
}

async function orderToPurchaseErrorView(id) {
  return Request('get', "api/purchases/order-to-purchase-error-view/" + id);
}

async function getInventoryReference(data) {
  return Request('get', "api/purchases/get-inventory-reference/", data);
}

// 导出采购备货参考
async function inventoryReferenceExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/purchases/inventory-reference-export/', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function update(data) {
  return Request('post', 'api/purchases/update', data)
}

async function saveExpress(id, data) {
  return Request('post', 'api/purchases/edit-express-price/' + id, data)
}

async function getSupplierPurchasePrices(id) {
  return Request('get', 'api/purchases/get-supplier-purchase-prices/' + id)
}

export default {
  fetch,
  fetchOne,
  fetchExamineDetail,
  add,
  addPreview,
  cancel,
  clone,
  exports,
  examine,
  confirm,
  edit,
  batchConfirm,
  batchExamine,
  stockoutFetch,
  purchasePrint,
  purchasesPrint,
  pushAgain,
  templateExport,
  Import,
  examineBatchExports,
  examineExport,
  fetchIntelligentDetails,
  fetchIntelligentPurchaseOrders,
  addIntelligentPreview,
  addIntelligent,
  getNegotiatePriceDetails,
  negotiatePriceSave,
  negotiatePriceBatchSave,
  editHopeDeliveryDate,
  orderToPurchaseError,
  orderToPurchaseErrorView,
  getInventoryReference,
  inventoryReferenceExport,
  update,
  purchaseToSupplierOrder,
  saveExpress,
  getSupplierPurchasePrices,
};
